module.exports = __webpack_public_path__ + "img/integration-module-1.3c42c9d9.png";